import i18n from '@/utils/i18n';
import React from 'react';
import { Chip, Icons } from '@usepepper/sprout-kit-ui';

interface Props {
  label: string;
  onClear: () => void;
}

export const UnpaidInvoicesBucketFilterChip: React.FC<Props> = ({
  label,
  onClear,
}) => (
  <Chip alignSelf="center" circular onPress={onClear} pressable>
    <Chip.Text color="$textSecondary" size="$sm">
      {i18n.t('finance_hub.invoices.bucket_filter_chip', { label })}
    </Chip.Text>
    <Chip.Icon alignSelf="center">
      <Icons.X />
    </Chip.Icon>
  </Chip>
);
